const kebabRegexp = /([a-z]|\s+)([A-Z])/g;
export const kebabCase = (string = '', delimiter = '-') => string.replace(kebabRegexp, `$1${delimiter}$2`).toLowerCase();

export const constructSeoTitle = (content, base) => {
    let seoTitle = base || "";
    if (content?.title && seoTitle.indexOf(content?.title) === -1) {
        seoTitle = `${content.title} | ${seoTitle}`
    }
    return seoTitle;
}